import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=0344c5cf&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=0344c5cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344c5cf",
  null
  
)

export default component.exports